import { Checkbox } from '@mui/material';
import { styled } from '../../stitches.config';

export const MuiBrandCheckbox = styled(Checkbox, {
  '&.Mui-checked': {
    color: '$brand9 !important',
  },
});
